// Cadastro (`spec/17-frontend.md` §8.1). AUTH-06: a rota continua existindo, mas só
// funciona com `?invite=<token>` válido: o servidor recusa o resto com
// `403 invite_required`, então a tela nem monta formulário sem convite.

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SignUpScreen } from '../features/invites/signup-screen.tsx';

const searchSchema = z.object({
  invite: z.string().optional(),
  /** WEB-140: cadastro pelo "Conectar com a Lezty Pay" (`spec/32` §8). */
  request_uri: z.string().optional(),
});

function SignUp() {
  const { invite, request_uri } = Route.useSearch();
  return <SignUpScreen token={invite} requestUri={request_uri} />;
}

export const Route = createFileRoute('/signup/')({
  component: SignUp,
  validateSearch: searchSchema,
});
